// @flow

// Libs
import { createSelector } from 'reselect'
import _map from 'lodash/map'

// Utils
import traverse from 'fc-utils/traverse'
import emptyArrayOr from 'fc-utils/emptyArrayOr'

// Constants
import { TREE, POINTS_BRANCH } from '../constants'

export default createSelector(
  [
    traverse([TREE, POINTS_BRANCH]),
  ],
  (samplingPoints: Object): Array => {
    return emptyArrayOr(_map(samplingPoints))
  }
)
